import React, { useState } from 'react';
import { Badge, Label } from '@nooz-optics/nooz-components-lib';
import { Image } from '../../../Media/Image/index';
import { IBlogArticle, IButton } from '../../../../../utils/types/contentful';
import { returnFormatedDate } from '../../../../../utils/globals';
import { withLocale } from '../../../../../utils/hocs';
import { CardImageHover } from '../../ImageHover';
import { Link } from '../../../Elements/Link';

export interface BlogArticleHightlightCardProps {
  article: IBlogArticle;
  button: IButton;
}

export const BlogArticleCard = withLocale(
  ({ article, button }: BlogArticleHightlightCardProps) => {
    const [isHover, setIsHover] = useState(false);

    const articleSubLabel = `${returnFormatedDate(article.createdAt)} | ${
      article.author?.name
    }`;

    return (
      <Link
        title='Go to blog article card'
        type='Page'
        slug={article.slug}
        className='w-full h-full bg-white cursor-pointer relative'
      >
        <div className='relative'>
          <div className='absolute z-1 flex p-2'>
            {article.categories?.map(({ color, label }) => (
              <div className='mr-2'>
                <Badge size='sm' type='white' dotColor={color} label={label} />
              </div>
            ))}
          </div>
          <div className='relative h-1/2'>
            <div
              onMouseEnter={() => setIsHover(true)}
              onMouseLeave={() => setIsHover(false)}
              className='hidden absolute w-full h-full lg:block z-10'
            >
              <CardImageHover isHover={isHover} button={button} />
            </div>
            <Image
              {...article.posterImage}
              objectFit='cover'
              height='100%'
              width='100%'
            />
          </div>
          <div className='flex flex-col justify-between h-1/2 p-2 sm:p-4'>
            <div className='w-full'>
              <Label text={articleSubLabel} size='sm' weight='light' truncate />
              <Label {...article.label} size='xl' weight='medium' />
            </div>
          </div>
        </div>
      </Link>
    );
  }
);
